import Vue from "vue";
import moment from "moment";

export default {
  currency: Vue.filter("currency", function (value) {
    return value && Number(value.toFixed(2)).toLocaleString();
  }),
  currencyInteger: Vue.filter("currencyInteger", function (value) {
    return value && Number(value.toFixed(0)).toLocaleString();
  }),
  uppercase: Vue.filter("uppercase", function (value) {
    return value && value.toUpperCase();
  }),
  formatDate: Vue.filter("formatDate", function (value) {
    return value && moment(value).format("DD/MM/YYYY");
  }),
  formatTime: Vue.filter("formatTime", function (value) {
    return value && moment(value).format("HH:mm");
  }),
  formatDateHour: Vue.filter("formatDateHour", function (value) {
    if (!value) return "";
    return moment(value).format("DD/MM/YYYY HH:mm");
  }),
  formatMonth: Vue.filter("formatMonth", function (value) {
    if (!value) return "";
    return moment(value).format("MM/YYYY");
  }),
  formatYear: Vue.filter("formatYear", function (value) {
    if (!value) return "";
    return moment(value).format("YYYY");
  }),
  diff: Vue.filter("diff", function (from, to, mode) {
    if (!from || !to) return "";
    if (!mode) mode = "days";
    return moment(from).startOf(mode).diff(moment(to).startOf(mode), mode);
  }),
  dayEndMonth: Vue.filter("dayEndMonth", function (value) {
    if (!value) return "";
    return moment(value).endOf("month").format("DD/MM/YYYY");
  }),
  formatDateCustom: Vue.filter("formatDateCustom", function (value, custom) {
    if (!value) return "";
    return custom
      ? moment(value).format(custom)
      : moment(value).format("DD/MM/YYYY");
  }),
  formatDateHourForComment: Vue.filter("formatDateHourForComment", function (
    value
  ) {
    if (!value) {
      return "";
    } else {
      if (
        moment(value).date() === moment().date() &&
        moment(value).month() === moment().month() &&
        moment(value).year() === moment().year()
      ) {
        return moment(value).fromNow();
      } else {
        return moment(value).format("DD/MM/YYYY HH:mm");
      }
    }
  }),
  numParseFloat: Vue.filter("numParseFloat", function (number, toNumber) {
    if (!number && isNaN(number)) {
      return "";
    } else if (+number === 0) {
      return 0;
    } else {
      let numCompare = 1;
      for (let i = 0; i < toNumber; i++) {
        numCompare += "0";
      }
      if (Number(number) === number && number % 1 !== 0) {
        return Math.round(number * numCompare) / numCompare;
      } else {
        return number;
      }
    }
  }),
  string: Vue.filter("string", function (value) {
    return value ? value + ":string" : "";
  }),
  stringHtml: Vue.filter("stringHtml", function (value) {
    return value ? value + "<span style='display:none'>:string</span>" : "";
  }),
  // currency: Vue.filter("currency", function (value, nation, unit) {
  //   if (!nation) nation = "vi-VN";
  //   if (!unit) unit = "VND";
  //   if (+value === 0) return 0;
  //   else if (+value > 0)
  //     return value.toLocaleString(nation, {
  //       style: "currency",
  //       currency: unit,
  //     });

  //   return "";
  // }),
};
